import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { getDiplomas } from "../api"; // Update the path as needed

export default function Diplomas() {
  const diplomas = getDiplomas();
  const [search, setSearch] = useState("");

  const filteredDiplomas = diplomas.filter((cat) =>
    cat.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="container">
      <h1>Schools</h1>
      <input
        type="text"
        placeholder="Search diplomas..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ marginBottom: "1em", padding: "0.5em" }}
      />
      <ul className="categories">
        {filteredDiplomas.map((cat) => (
          <li key={cat.id}>
            <NavLink to={cat.id}>{cat.name}</NavLink>
          </li>
        ))}
      </ul>
      <Outlet />
    </div>
  );
}
